var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-full md_w-1-3 lg_w-1-2 font-archivo" },
    [
      _c(
        "buyer-select",
        {
          staticClass: "md_max-w-xs mx-1 mt-3_5 md_m-0",
          attrs: {
            "hide-label": "hide-label",
            label: "Country",
            type: "footer",
            value: _vm.customer.country
          },
          on: { input: _vm.inputSelectCountry }
        },
        _vm._l(_vm.countries, function(country, code) {
          return _c("option", { domProps: { value: code } }, [
            _vm._v(
              _vm._s(
                code === _vm.customer.country
                  ? "(" + _vm.currencyInfo.currency_symbol + ") " + country
                  : country
              )
            )
          ])
        }),
        0
      ),
      _c("img", {
        directives: [
          {
            name: "lazy",
            rawName: "v-lazy",
            value: _vm.securityImg,
            expression: "securityImg"
          }
        ],
        staticClass: "opacity-100 mt-2 md_max-w-xs w-full px-2_5 md_p-0",
        attrs: { alt: "security seals" }
      }),
      _c(
        "div",
        { staticClass: "text-brand-secondary-800 mt-5 text-center md_text-sm" },
        [
          _vm._v(
            "Copyright © " +
              _vm._s(_vm.year) +
              " ViralStyle. All rights reserved."
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "flex mt-_5 items-center leading-none justify-center" },
        [
          _c(
            "router-link",
            {
              staticClass:
                "text-brand-secondary-400 text-center md_text-sm hover_underline",
              attrs: { to: { name: "privacy" } }
            },
            [_vm._v("Privacy Policy")]
          ),
          _c("div", { staticClass: "text-brand-secondary-800" }, [
            _vm._v(" | ")
          ]),
          _c(
            "router-link",
            {
              staticClass:
                "text-brand-secondary-400 text-center md_text-sm hover_underline",
              attrs: { to: { name: "terms" } }
            },
            [_vm._v("Terms of Service")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }